import { render, staticRenderFns } from "./OrdenCompraForm.vue?vue&type=template&id=07518d26"
import script from "./OrdenCompraForm.vue?vue&type=script&lang=js"
export * from "./OrdenCompraForm.vue?vue&type=script&lang=js"
import style0 from "./OrdenCompraForm.vue?vue&type=style&index=0&id=07518d26&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports